<template>
  <div
    v-if="translations.buttons && translations.activity && translations.table"
  >
    <div class="d-flex justify-content-start mb-2">
      <button
      class="btn btn-danger mx-2 align-left"
      type="button"
      @click="PopupAction('remove')"
      >
      {{ translations.buttons.btn_remove_event }}
    </button>
    <button
      class="btn btn-primary mx-2"
      type="button"
      v-if="type != 'next'"
      @click="PopupAction('read')"
    >
      {{ translations.buttons.btn_show_event }}
    </button>
    <button
      class="btn btn-primary mx-2"
      type="button"
      v-if="type != 'next'"
      @click="PopupAction('share')"
    >
      {{ translations.buttons.btn_share }}
    </button>
    <button
      class="btn btn-primary"
      type="button"
      v-if="type == 'next'"
      @click="PopupAction('edit')"
    >
      {{ translations.buttons.btn_edit_event }}
    </button>
    <button
      class="btn btn-primary mx-2"
      type="button"
      v-if="type == 'next'"
      @click="PopupAction('share')"
    >
      {{ translations.buttons.btn_share }}
    </button>
  </div>
    <div v-if="type == 'next'" class="marginburrons">
      <div>
        <button
          class="btn btn-primary w-100"
          @click="PopupAction('confirm')"
          v-if="event.status < 1"
        >
          {{ translations.buttons.btn_enable_event }}
        </button>
      </div>
      <hr>
      <div class="mt-3 mb-2 buttoncont">
        <button 
          class="btn btn-primary" 
          @click="PopupAction('add')"
          type="button"
        >
          {{ translations.buttons.btn_add_activity }}
        </button>
      </div>
    </div>
    <h1>{{ translations.activity.title }}</h1>
    <table class="table table-striped" id="customers">
      <thead>
        <tr>
          <th class="col">{{ translations.table.tb_title }}</th>
          <th class="col">{{ translations.table.tb_day }}</th>
          <th class="col">{{ translations.table.tb_hour }}</th>
          <th class="col" v-if="chekPremium">
            {{ translations.table.tb_views }}
          </th>
          <th class="col" v-if="chekPremium">
            {{ translations.table.tb_points }}
          </th>
          <th class="col" v-if="chekPremium">
            {{ translations.table.tb_feedback }}
          </th>
          <th class="col" v-if="chekPremium">
            {{ translations.table.tb_subscriber }}
          </th>

          <th class="col" v-if="type != 'historical'">
            {{ translations.table.tb_action }}
          </th>
        </tr>
      </thead>

      <tbody class="list" v-if="activities.length !== 0">
        <tr v-for="(item, index) in activities" :key="index">
          <th class="col align-middle" @click="edit(item.id)">
            {{ defineTitle(item.title) }}
          </th>
          <td class="col align-middle" @click="edit(item.id)">
            {{ item.day }}
          </td>
          <td class="col align-middle" @click="edit(item.id)">
            {{ item.time }}
          </td>
          <td
            class="col align-middle"
            @click="edit(item.id)"
            v-if="chekPremium"
          >
            {{ item.views }}
          </td>
          <td
            class="col align-middle"
            @click="edit(item.id)"
            v-if="chekPremium"
          >
            {{ item.points }}
          </td>
          <td
            class="col align-middle"
            @click="edit(item.id)"
            v-if="chekPremium"
          >
            {{ item.feedback }}
          </td>
          <td
            class="col align-middle"
            @click="edit(item.id)"
            v-if="chekPremium"
          >
            {{ item.subscribers }}
          </td>
          <td class="col align-middle" v-if="type != 'historical'">
            <div v-if="type == 'next'">
              <button class="btn btn-danger m-1" @click="callConfirm(item)">
                <img :src="require('@/assets/icon/false.svg')" class="svg" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody class="bg-empty" v-else>
        <tr>
          <td :colspan="checkColspan" class="col-12">
            <Alert type="warning" :message="translations.errors.activity_table"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Alert from '@/components/atoms/Alert.vue'

  export default {
    name: 'Activities',
    components: {
      Alert,
    },
    props: {
      event: {
        type: Object,
        default: {},
      },
      type: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        languages: this.event.languages,
      }
    },
    computed: {
      ...mapState(['activities', 'languageSelected', 'translations']),

      checkColspan() {
        let result = 8
        if (this.event.premium === 0) {
          result = 4
        }
        return result
      },
      chekPremium() {
        return this.event.premium == 2
      },
    },
    watch: {
      async $route(to, from) {
        if (to == "Activities") {
          await this.getActivities(this.event.id)
          await this.setEventLanguages(this.languages)
          await this.setEventDays(this.event)
        }
      },
    },
    methods: {
      ...mapActions([
        'getActivities',
        'changeToolSelected',
        'setEventLanguages',
        'deleteActivity',
        'saveActivityID',
        'setEventDays',
        'resetActivities',
        'saveConfirm',
      ]),

      async PopupAction(value) {
        let action = null
        switch (value) {
          case 'share':
            action = 15
            break
          case 'add':
            action = 10
            break
          case 'read':
            action = 22
            break
          case 'remove':
            action = 40
            await this.saveConfirm({
              type: 'event',
              id: this.event.id,
              data: this.defineTitle(this.event.title),
              event_id: this.event.id,
            })
            break
          case 'edit':
            action = 13
            break
          case 'confirm':
            action = 41
            await this.saveConfirm({
              type: 'event',
              data: this.event,
            })
            break
        }
        this.changeToolSelected(action)
      },
      async edit(id) {
        await this.saveActivityID({ id: id, type: 'get' })
        let num = 11
        if (this.type == 'historical') {
          num = 12
        }
        this.changeToolSelected(num)
      },
      delet(id) {
        let data = { id: id, event_id: this.event.id }
        this.deleteActivity(data)
      },
      async callConfirm(item) {
        await this.saveConfirm({
          type: 'activity',
          id: item.id,
          data: this.defineTitle(item.title),
          event_id: this.event.id,
        })
        this.changeToolSelected(40)
      },

      defineTitle(title) {
        let text = ''
        if (title) {
          let result = title.find((x) => x.key === this.languageSelected)
          text = result && result.text ? result.text : title[0].text
        }

        return text
      },
    },
    async created() {
      await this.getActivities(this.event.id)
      await this.setEventLanguages(this.languages)
      await this.setEventDays(this.event)
    },
    beforeUnmount() {
      this.resetActivities()
    },
  }
</script>

<style scoped>
  .svg {
    filter: invert(100%) sepia(96%) saturate(16%) hue-rotate(278deg)
      brightness(105%) contrast(104%);
  }
  .list tr:hover {
    background-color: #cecece;
    cursor: pointer;
  }
  .buttoncont{
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    
  }
  .marginburrons {
    margin: 0 5px
  }
  .buttoncont button{
      margin: 5px 0 ;
    }
  @media screen and (min-width: 800px) {
    .buttoncont button{
      margin: 5px ;
    }
    .buttoncont{
      flex-direction: row;
      justify-content: center;
    }
  }

</style>
